import React from 'react';
import { Icon, IconType } from '@99designs/frontend-components/components/Icon';
import { Site } from '../../lib/Site';
import LocaleSwitcher from '../LocaleSwitcher/LocaleSwitcher';

interface Props {
    site: Site;
}

export default function SiteFooterSub({ site }: Props) {
    const languages = site.getSwitchableLanguages();
    const socialLinks: { href: string; icon: IconType; title: string }[] = [
        {
            href: `https://www.facebook.com/${site.getSocialMediaHandleFor('facebook')}`,
            icon: 'facebook-2',
            title: 'Facebook',
        },
        {
            href: `https://www.twitter.com/${site.getSocialMediaHandleFor('twitter')}`,
            icon: 'twitter-1',
            title: 'Twitter',
        },
        {
            href: 'https://www.linkedin.com/company/99designs',
            icon: 'linkedin-4',
            title: 'LinkedIn',
        },
        {
            href: 'https://pinterest.com/99designs',
            icon: 'pinterest-2',
            title: 'Pinterest',
        },
        {
            href: 'https://www.instagram.com/99designs/',
            icon: 'instagram-1',
            title: 'Instagram',
        },
    ];

    return (
        <div className="site-footer__sub">
            <div className="site-footer__sub__inner">
                <div className="site-footer__legal">
                    <span className="site-footer__legal__copyright-message">
                        {__('© 99designs')}
                    </span>
                    <span className="site-footer__legal__parent">{__('by Vista')}</span>
                    <div className="site-footer__legal__privacy-links">
                        <ul className="footer-level-nav--with-dividers">
                            <li className="footer-level-nav__item">
                                <a
                                    className="footer-level-nav__item__link"
                                    href="/legal/terms-and-conditions"
                                >
                                    {__('Terms and Conditions')}
                                </a>
                            </li>
                            <li className="footer-level-nav__item">
                                <a className="footer-level-nav__item__link" href="/legal/privacy">
                                    {__('Privacy')}
                                </a>
                            </li>
                            {site.hasCapability('about_imprint') && (
                                <li className="footer-level-nav__item">
                                    <a
                                        className="footer-level-nav__item__link"
                                        href="/legal/imprint"
                                    >
                                        {__('Imprint')}
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
                {languages.length > 1 && (
                    <div className="site-footer__language">
                        <LocaleSwitcher languages={languages} />
                    </div>
                )}
                <div className="site-footer__socials">
                    <ul className="footer-level-nav">
                        {socialLinks.map((socialLink) => {
                            return (
                                <li className="footer-level-nav__item" key={socialLink.icon}>
                                    <a
                                        href={socialLink.href}
                                        className="icon-button icon-button--simple"
                                        aria-label={socialLink.title}
                                    >
                                        <Icon type={socialLink.icon} />
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </div>
    );
}
